@charset "UTF-8";

/* src/app/components/v2-request-physical-collection/v2-request-physical-collection.component.scss */
:host {
  display: contents;
}
body.v2-request-phys-col-open {
  overflow: hidden;
}
.v2-request-phys-col {
  position: fixed;
  inset: 0;
  height: 100%;
  max-height: 100dvh;
  z-index: 10002;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  transform-origin: 50% 50%;
  animation: v2-request-phys-col-enter 0.4s cubic-bezier(0.22, 1, 0.36, 1) both;
  background: var(--exme-overlay-atmosphere-background);
}
.v2-request-phys-col.v2-request-phys-col--closing {
  pointer-events: none;
  animation: v2-request-phys-col-exit 0.4s cubic-bezier(0.22, 1, 0.36, 1) both;
}
@keyframes v2-request-phys-col-enter {
  from {
    opacity: 0;
    transform: scale(0.96) translateY(10px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}
@keyframes v2-request-phys-col-exit {
  from {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
  to {
    opacity: 0;
    transform: scale(0.96) translateY(8px);
  }
}
@media (prefers-reduced-motion: reduce) {
  .v2-request-phys-col {
    animation: none;
  }
  .v2-request-phys-col.v2-request-phys-col--closing {
    animation: none;
    opacity: 0;
  }
}
.v2-request-phys-col .v2-rpc-overlay-request-loader {
  position: absolute;
  inset: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100;
  transition: opacity 0.3s ease;
}
.v2-request-phys-col .v2-rpc-overlay-request-loader .loader {
  width: 100px;
  height: 100px;
}
.v2-request-phys-col .v2-rpc-body.v2-rpc-body--requests-loading {
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.25s ease;
}
@media (prefers-reduced-motion: reduce) {
  .v2-request-phys-col .v2-rpc-overlay-request-loader {
    transition: opacity 0.15s ease;
  }
  .v2-request-phys-col .v2-rpc-body.v2-rpc-body--requests-loading {
    transition: opacity 0.15s ease;
  }
}
.v2-request-phys-col main.v2-rpc-scroll {
  scrollbar-width: none;
  -ms-overflow-style: none;
}
.v2-request-phys-col main.v2-rpc-scroll::-webkit-scrollbar {
  display: none;
}
.v2-rpc-floating-close {
  position: absolute;
  top: 0.65rem;
  right: calc(0.65rem + env(safe-area-inset-right));
  z-index: 60;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  margin: 0;
  padding: 0;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  font-family: inherit;
  font-size: 1.5rem;
  line-height: 1;
  color: rgba(13, 18, 24, 0.9);
  background: rgba(255, 255, 255, 0.95);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  opacity: 0;
  transform: translateY(-12px) scale(0.92);
  transition: opacity 0.45s cubic-bezier(0.22, 1, 0.36, 1), transform 0.45s cubic-bezier(0.22, 1, 0.36, 1);
}
.v2-rpc-floating-close.v2-rpc-floating-in {
  opacity: 1;
  transform: translateY(0) scale(1);
}
.v2-rpc-floating-close:active {
  transform: scale(0.9);
}
.v2-rpc-floating-close.v2-rpc-floating-in:active {
  transform: scale(0.9);
}
body.dark .v2-rpc-floating-close {
  color: rgba(255, 255, 255, 0.92);
  background: rgba(22, 28, 36, 0.9);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.28);
}
.v2-request-phys-col .v2-rpc-floating-close {
  backdrop-filter: none;
  -webkit-backdrop-filter: none;
}
.v2-rpc-title-pill {
  position: absolute;
  top: 1.1rem;
  left: 50%;
  z-index: 55;
  width: max-content;
  max-width: min(88vw, 20rem);
  padding: 0.42rem 0.95rem;
  text-align: center;
  font-size: 0.78rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  line-height: 1.35;
  color: rgba(13, 18, 24, 0.92);
  pointer-events: none;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.94);
  border: 1px solid rgba(13, 18, 24, 0.07);
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  transform: translate(-50%, -8px);
  opacity: 0;
  transition: opacity 0.45s cubic-bezier(0.22, 1, 0.36, 1) 0.04s, transform 0.45s cubic-bezier(0.22, 1, 0.36, 1) 0.04s;
}
.v2-rpc-title-pill.v2-rpc-floating-in {
  opacity: 1;
  transform: translate(-50%, 0);
}
body.dark .v2-rpc-title-pill {
  color: rgba(255, 255, 255, 0.94);
  background: rgba(22, 28, 36, 0.92);
  border-color: rgba(255, 255, 255, 0.12);
  box-shadow: 0 2px 14px rgba(0, 0, 0, 0.3);
}
.v2-rpc-body {
  flex: 1;
  min-height: 0;
  position: relative;
  display: flex;
  flex-direction: column;
}
.v2-rpc-scroll-outer {
  flex: 1;
  min-height: 0;
  -webkit-overflow-scrolling: touch;
  padding-left: env(safe-area-inset-left);
  padding-right: env(safe-area-inset-right);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.v2-request-phys-col-scroll {
}
main.v2-rpc-scroll {
  flex: 1;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding: 3.6rem 0.85rem 1.25rem;
  padding-bottom: calc(1.25rem + env(safe-area-inset-bottom));
  box-sizing: border-box;
  display: block;
  background: transparent;
}
.manage-wrapper.v2-req-phys-wrap {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: min(32rem, 100%);
  margin-inline: auto;
  padding: 0;
}
.v2-rpc-submit-wrap {
  max-width: min(32rem, 100%);
  margin: 1.25rem auto 0;
  padding: 0 0.85rem calc(1rem + env(safe-area-inset-bottom));
}
.v2-rpc-submit-end {
  width: 100%;
  margin: 0;
}
.v2-rpc-submit-end .btn-wrapper {
  width: 100%;
}
.v2-rpc-submit-end .btn-wrapper .btn {
  min-height: 50px;
  width: 100%;
  border-radius: 14px;
  font-weight: 700;
  letter-spacing: 0.02em;
}
.v2-req-phys-wrap .v2-rpc-item {
  background: rgba(255, 255, 255, 0.7);
  border-radius: 16px;
  padding: 12px 14px;
  min-height: 52px;
  margin-bottom: 0.55rem;
  border: 1px solid rgba(13, 18, 24, 0.07) !important;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
}
body.dark .v2-req-phys-wrap .v2-rpc-item {
  background: rgba(22, 28, 36, 0.7);
  border-color: rgba(255, 255, 255, 0.08) !important;
  box-shadow: 0 2px 14px rgba(0, 0, 0, 0.25);
}
.v2-req-phys-wrap .v2-rpc-incomplete-gate {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  padding-bottom: 0.35rem;
}
.v2-req-phys-wrap .v2-rpc-incomplete-gate__message .v2-rpc-lbl {
  text-align: center;
}
.v2-req-phys-wrap .v2-rpc-incomplete-gate__title {
  margin: 0 0 0.65rem;
  font-size: 1.15rem;
  font-weight: 800;
  line-height: 1.35;
  color: var(--ion-color-text, #1a1a1a);
}
.v2-req-phys-wrap .v2-rpc-incomplete-gate__body {
  margin: 0;
  font-size: 0.95rem;
  line-height: 1.5;
  color: rgba(13, 18, 24, 0.72);
}
body.dark .v2-req-phys-wrap .v2-rpc-incomplete-gate__title {
  color: var(--ion-color-text, #fff);
}
body.dark .v2-req-phys-wrap .v2-rpc-incomplete-gate__body {
  color: rgba(255, 255, 255, 0.72);
}
.v2-req-phys-wrap .v2-rpc-incomplete-gate__divider {
  margin-top: 0.5rem !important;
  padding-top: 1rem !important;
}
.v2-req-phys-wrap .v2-rpc-incomplete-gate__primary {
  margin-bottom: 0.15rem;
}
.v2-req-phys-wrap .v2-rpc-incomplete-gate__footer {
  display: flex;
  justify-content: center;
  margin-top: 0.35rem;
  padding: 0.85rem 0 0.25rem;
  border-top: 1px solid rgba(13, 18, 24, 0.1);
}
body.dark .v2-req-phys-wrap .v2-rpc-incomplete-gate__footer {
  border-top-color: rgba(255, 255, 255, 0.1);
}
.v2-req-phys-wrap .v2-rpc-incomplete-gate__dismiss-btn {
  max-width: 100%;
}
.v2-req-phys-wrap .v2-rpc-section-divider {
  background: transparent !important;
  border: none !important;
  min-height: auto !important;
  padding: 1.35rem 0 0.4rem !important;
  margin-top: 0.25rem;
}
.v2-req-phys-wrap .v2-rpc-section-divider .v2-rpc-lbl {
  font-size: 0.68rem !important;
  font-weight: 700 !important;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: rgba(13, 18, 24, 0.5) !important;
}
body.dark .v2-req-phys-wrap .v2-rpc-section-divider .v2-rpc-lbl {
  color: rgba(255, 255, 255, 0.45) !important;
}
.v2-rpc-native-input,
.v2-rpc-native-textarea {
  width: 100%;
  box-sizing: border-box;
  padding: 10px 12px;
  border-radius: 12px;
  border: 1px solid rgba(13, 18, 24, 0.12);
  background: rgba(255, 255, 255, 0.85);
  color: var(--ion-color-text, #1a1a1a);
  font-size: 1rem;
}
body.dark .v2-rpc-native-input,
body.dark .v2-rpc-native-textarea {
  background: rgba(22, 28, 36, 0.75);
  border-color: rgba(255, 255, 255, 0.12);
  color: var(--ion-color-text, #fff);
}
.v2-rpc-native-input:focus,
.v2-rpc-native-textarea:focus {
  outline: none;
  border-color: var(--ion-color-primary, #3880ff);
  box-shadow: 0 0 0 3px rgba(var(--ion-color-primary-rgb, 56, 128, 255), 0.2);
}
.v2-rpc-field-label {
  display: block;
  font-size: 0.8rem;
  font-weight: 600;
  margin-bottom: 0.35rem;
  color: var(--ion-color-text, #1a1a1a);
}
.v2-rpc-radio-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  width: 100%;
}
.v2-rpc-radio-row {
  display: flex;
  align-items: flex-start;
  gap: 0.65rem;
  cursor: pointer;
  width: 100%;
}
.v2-req-phys-wrap .v2-rpc-radio-group input[type=radio] {
  margin-top: 0.35rem;
  flex-shrink: 0;
  width: 18px;
  height: 18px;
  cursor: pointer;
  accent-color: var(--ion-color-primary);
}
.v2-rpc-radio-row__body {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
}
.v2-rpc-radio-row__title {
  font-weight: 600;
  color: var(--ion-color-text);
}
.v2-rpc-radio-row__sub {
  font-size: 0.85rem;
  opacity: 0.85;
  color: var(--ion-color-text);
}
.v2-rpc-radio-row__text {
  flex: 1;
  color: var(--ion-color-text);
}
.v2-rpc-check-row {
  display: flex;
  align-items: center;
  gap: 0.55rem;
  color: var(--ion-color-text);
  cursor: pointer;
  width: 100%;
}
.v2-req-phys-wrap .v2-rpc-check-row input {
  width: 18px;
  height: 18px;
  cursor: pointer;
  accent-color: var(--ion-color-primary);
}
.v2-rpc-row {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  margin: 0 -4px;
}
.v2-rpc-col {
  flex: 1;
  min-width: 0;
  padding: 1px 4px;
}
.v2-rpc-col--span-12 {
  flex: 0 0 100%;
  max-width: 100%;
  color: var(--ion-color-text);
}
.v2-rpc-grid {
  margin-top: 20px;
  width: 100%;
}
.v2-rpc-grid .v2-rpc-row {
  text-align: center;
}
.v2-rpc-grid--fixed .v2-rpc-row:last-child {
  position: fixed;
  bottom: 20px;
  left: 0;
  right: 0;
}
.v2-rpc-grid--fixed .v2-rpc-row:nth-child(2) {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.v2-rpc-grid--fixed .v2-rpc-row:nth-child(3) {
  position: fixed;
  top: 70%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.v2-rpc-action-btn {
  width: 100%;
}
.v2-rpc-action-btn .btn-wrapper {
  width: 100%;
}
.v2-rpc-action-btn .btn-wrapper .btn {
  min-height: 45px;
  width: 100%;
  border-radius: 14px;
  font-weight: 600;
  font-size: 0.9rem;
}
.v2-rpc-inline-spinner {
  display: inline-block;
  width: 28px;
  height: 28px;
  border: 3px solid rgba(0, 0, 0, 0.12);
  border-top-color: var(--ion-color-primary, #3880ff);
  border-radius: 50%;
  animation: v2-rpc-spin 0.8s linear infinite;
}
@keyframes v2-rpc-spin {
  to {
    transform: rotate(360deg);
  }
}
.v2-rpc-summary {
  display: block;
}
.v2-rpc-summary-lines {
  display: flex;
  flex-direction: column;
  gap: 0.55rem;
  margin-bottom: 0.75rem;
  padding-bottom: 0.75rem;
  border-bottom: 1px solid rgba(13, 18, 24, 0.1);
}
body.dark .v2-rpc-summary-lines {
  border-bottom-color: rgba(255, 255, 255, 0.12);
}
.v2-rpc-summary-line {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 1rem;
}
.v2-rpc-summary-line__label {
  font-size: 0.92rem;
  color: var(--ion-color-text);
  opacity: 0.88;
}
.v2-rpc-summary-line__value {
  font-size: 0.95rem;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  text-align: right;
  color: var(--ion-color-text);
}
.v2-rpc-summary-total {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 1rem;
  padding-top: 0.1rem;
}
.v2-rpc-summary-total__label {
  font-size: 1.02rem;
  font-weight: 700;
  color: var(--ion-color-text);
}
.v2-rpc-summary-total__value {
  font-size: 1.12rem;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  color: var(--ion-color-text);
}
.v2-rpc-summary-total--only {
  padding-top: 0;
  margin: 0;
}
.v2-rpc-mbway-block {
  padding-top: 12px;
  padding-bottom: 12px;
}
.v2-rpc-mbway-grid {
  display: grid;
  grid-template-columns: 1fr auto;
  grid-template-areas: "label label" "input save" "error error";
  column-gap: 1rem;
  row-gap: 0.45rem;
  align-items: center;
}
.v2-rpc-mbway-grid__label {
  grid-area: label;
  margin-bottom: 0;
}
.v2-rpc-mbway-grid__input {
  grid-area: input;
  width: 100%;
  min-width: 0;
}
.v2-rpc-mbway-grid__save {
  grid-area: save;
  color: var(--ion-color-text);
  margin: 0;
  align-self: center;
  white-space: nowrap;
}
.v2-rpc-mbway-grid__save .v2-rpc-check-row {
  margin: 0;
}
.v2-rpc-mbway-grid__error {
  grid-area: error;
  margin: 0;
  padding-left: 0 !important;
}
@media (max-width: 360px) {
  .v2-rpc-mbway-grid {
    grid-template-columns: 1fr;
    grid-template-areas: "label" "input" "save" "error";
  }
  .v2-rpc-mbway-grid__save {
    justify-self: start;
  }
}
.v2-rpc-error-line {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: var(--ion-color-danger) !important;
}
.v2-rpc-alert-dot {
  flex-shrink: 0;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: var(--ion-color-danger);
  box-shadow: 0 0 0 3px rgba(var(--ion-color-danger-rgb), 0.25);
}
.v2-req-phys-wrap .loader-parent {
  padding: 1.5rem 0.5rem 2rem;
}
.v2-req-phys-wrap .loader-text-available,
.v2-req-phys-wrap .loader-text-Not-Available,
.v2-req-phys-wrap .loader-text-Wait,
.v2-req-phys-wrap .loader-text-pending-payment,
.v2-req-phys-wrap .loader-text-Waiting-Dispatch,
.v2-req-phys-wrap .loader-text-Dispatched,
.v2-req-phys-wrap .loader-text-Received,
.v2-req-phys-wrap .loader-text-OnHold,
.v2-req-phys-wrap .loader-text-Didnt-Receive,
.v2-req-phys-wrap .loader-text-Cancelled {
  text-shadow: 0 1px 2px rgba(255, 255, 255, 0.6);
}
body.dark .v2-req-phys-wrap .loader-text-available,
body.dark .v2-req-phys-wrap .loader-text-Not-Available,
body.dark .v2-req-phys-wrap .loader-text-Wait,
body.dark .v2-req-phys-wrap .loader-text-pending-payment,
body.dark .v2-req-phys-wrap .loader-text-Waiting-Dispatch,
body.dark .v2-req-phys-wrap .loader-text-Dispatched,
body.dark .v2-req-phys-wrap .loader-text-Received,
body.dark .v2-req-phys-wrap .loader-text-OnHold,
body.dark .v2-req-phys-wrap .loader-text-Didnt-Receive,
body.dark .v2-req-phys-wrap .loader-text-Cancelled {
  text-shadow: 0 2px 12px rgba(0, 0, 0, 0.5);
}
.v2-req-phys-wrap .loader-parent h1[class*=loader-text-]:not(.loader-text-running) {
  animation: none !important;
  opacity: 0;
  transform: translateY(100%);
}
@media (prefers-reduced-motion: reduce) {
  .v2-rpc-floating-close,
  .v2-rpc-title-pill {
    transition: none;
  }
  .v2-rpc-floating-close.v2-rpc-floating-in,
  .v2-rpc-title-pill.v2-rpc-floating-in {
    opacity: 1;
    transform: translateY(0);
  }
  .v2-rpc-title-pill.v2-rpc-floating-in {
    transform: translate(-50%, 0);
  }
  .v2-req-phys-wrap .loader-parent h1[class*=loader-text-]:not(.loader-text-running) {
    opacity: 0;
  }
  .v2-req-phys-wrap .loader-parent h1[class*=loader-text-].loader-text-running {
    animation: none !important;
    opacity: 1;
    transform: none;
  }
}
.col-icon {
  width: 25%;
  border-radius: 20px;
  padding: 10px;
}
.col-icon-large {
  width: 75%;
  border-radius: 20px;
  padding: 10px;
}
.col-div {
  width: 100%;
}
.placeholder-visible {
  opacity: unset !important;
}
.dimmed {
  opacity: 0.2;
}
.end-of-page-btns {
  bottom: 0px;
  width: 100%;
  z-index: 100;
  background-color: white;
}
.top-20 {
  margin-top: 20px;
}
.add-scrolling {
  padding-bottom: 20px;
  overflow-y: scroll;
}
.no-padding {
  padding: 0px;
}
.counter {
  font-size: 20px;
}
.code {
  font-size: 24px;
}
.phone-prefix {
  margin-right: 5px;
  white-space: nowrap;
}
.quantity-select {
  max-width: 80px;
}
.error-message {
  color: var(--ion-color-danger);
  display: block;
  font-size: smaller;
  padding-left: 20px;
}
.item-expand {
  margin-top: 10px;
  width: 100% !important;
}
.item-expand .item-inner--order-qty-row {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 0.65rem 0.85rem;
  width: 100%;
}
.item-expand .item-inner--order-qty-row .item-input-wrapper.v2-rpc-order-col--qty {
  float: none;
  flex: 0 0 auto;
  width: auto;
  min-width: 7.5rem;
  max-width: 11rem;
}
.item-expand .item-inner--order-qty-row .v2-rpc-qty-stepper-field {
  display: flex;
  flex-direction: column;
  align-items: stretch;
}
.item-expand .item-inner--order-qty-row .v2-rpc-qty-stepper {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 0;
  box-sizing: border-box;
  min-height: 42px;
  padding: 0;
  border-radius: 12px;
  border: 1px solid rgba(13, 18, 24, 0.12);
  background: rgba(255, 255, 255, 0.85);
  overflow: hidden;
}
.item-expand .item-inner--order-qty-row .v2-rpc-qty-stepper__btn {
  flex: 0 0 auto;
  margin: 0;
  min-width: 2.5rem;
  height: 100%;
  min-height: 42px;
  padding: 0 0.5rem;
  border: none;
  border-radius: 0;
  background: transparent;
  color: var(--ion-color-primary, #3880ff);
  font-size: 1.35rem;
  font-weight: 600;
  line-height: 1;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}
.item-expand .item-inner--order-qty-row .v2-rpc-qty-stepper__btn:hover:not(:disabled) {
  background: rgba(var(--ion-color-primary-rgb, 56, 128, 255), 0.08);
}
.item-expand .item-inner--order-qty-row .v2-rpc-qty-stepper__btn:disabled {
  opacity: 0.35;
  cursor: not-allowed;
}
.item-expand .item-inner--order-qty-row .v2-rpc-qty-stepper__value {
  flex: 1 1 auto;
  min-width: 1.5rem;
  text-align: center;
  font-size: 1rem;
  font-weight: 600;
  color: var(--ion-color-text, #1a1a1a);
  -webkit-user-select: none;
  user-select: none;
}
.item-expand .item-inner--order-qty-row .v2-rpc-order-col--unit-price {
  flex: 1 1 0;
  min-width: 0;
  text-align: right;
}
.item-expand .item-inner--order-qty-row .v2-rpc-order-col--unit-price p {
  margin: 0;
  font-size: 0.88rem;
  line-height: 1.35;
}
body.dark .item-expand .item-inner--order-qty-row .v2-rpc-qty-stepper {
  background: rgba(22, 28, 36, 0.75);
  border-color: rgba(255, 255, 255, 0.12);
  color: var(--ion-color-text, #fff);
}
body.dark .item-expand .item-inner--order-qty-row .v2-rpc-qty-stepper__value {
  color: var(--ion-color-text, #fff);
}
body.dark .item-expand .item-inner--order-qty-row .v2-rpc-qty-stepper__btn:hover:not(:disabled) {
  background: rgba(var(--ion-color-primary-rgb, 56, 128, 255), 0.14);
}
@media (max-width: 420px) {
  .item-expand .item-inner--order-qty-row {
    flex-direction: column;
    align-items: stretch;
  }
  .item-expand .item-inner--order-qty-row .v2-rpc-order-col--unit-price {
    text-align: left;
  }
  .item-expand .item-inner--order-qty-row .item-input-wrapper.v2-rpc-order-col--qty {
    width: 100%;
    max-width: none;
  }
}
.loader-parent {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}
.loader {
  width: 100%;
  height: 250px;
}
.loader-text-available {
  font-size: 20px;
  font-weight: bold;
  margin: 20px;
  min-height: 50px;
  text-align: center;
  animation: loader-text-available 4s infinite ease-in-out;
}
@keyframes loader-text-available {
  0% {
    opacity: 0;
    transform: translateY(100%);
  }
  15% {
    opacity: 0;
    transform: translateY(100%);
  }
  30% {
    opacity: 1;
    transform: translateY(0%);
  }
  60% {
    opacity: 1;
    transform: translateY(0%);
  }
  75% {
    opacity: 0;
    transform: translateY(-100%);
  }
  100% {
    opacity: 0;
    transform: translateY(-100%);
  }
}
.loader-text-pending-payment {
  font-size: 20px;
  font-weight: bold;
  margin: 20px;
  min-height: 50px;
  text-align: center;
  animation: loader-text-pending-payment 3.4s infinite ease-in-out;
}
@keyframes loader-text-pending-payment {
  0% {
    opacity: 0;
    transform: translateY(100%);
  }
  15% {
    opacity: 0;
    transform: translateY(100%);
  }
  25% {
    opacity: 1;
    transform: translateY(0%);
  }
  75% {
    opacity: 1;
    transform: translateY(0%);
  }
  85% {
    opacity: 0;
    transform: translateY(-100%);
  }
  100% {
    opacity: 0;
    transform: translateY(-100%);
  }
}
.loader-text-Waiting-Dispatch {
  font-size: 20px;
  font-weight: bold;
  margin: 20px;
  min-height: 50px;
  text-align: center;
  animation: loader-text-Waiting-Dispatch 4.2s infinite ease-in-out;
}
@keyframes loader-text-Waiting-Dispatch {
  0% {
    opacity: 0;
    transform: translateY(100%);
  }
  15% {
    opacity: 0;
    transform: translateY(100%);
  }
  30% {
    opacity: 1;
    transform: translateY(0%);
  }
  60% {
    opacity: 1;
    transform: translateY(0%);
  }
  75% {
    opacity: 0;
    transform: translateY(-100%);
  }
  100% {
    opacity: 0;
    transform: translateY(-100%);
  }
}
.loader-text-Dispatched {
  font-size: 20px;
  font-weight: bold;
  margin: 20px;
  min-height: 75px;
  text-align: center;
  animation: loader-text-Dispatched 5.15s infinite ease-in-out;
}
@keyframes loader-text-Dispatched {
  0% {
    opacity: 0;
    transform: translateY(100%);
  }
  10% {
    opacity: 0;
    transform: translateY(100%);
  }
  20% {
    opacity: 1;
    transform: translateY(0%);
  }
  80% {
    opacity: 1;
    transform: translateY(0%);
  }
  90% {
    opacity: 0;
    transform: translateY(-100%);
  }
  100% {
    opacity: 0;
    transform: translateY(-100%);
  }
}
.loader-text-Received {
  font-size: 20px;
  font-weight: bold;
  margin: 20px;
  min-height: 50px;
  text-align: center;
  animation: loader-text-Received 3.9s infinite ease-in-out;
}
@keyframes loader-text-Received {
  0% {
    opacity: 0;
    transform: translateY(100%);
  }
  10% {
    opacity: 0;
    transform: translateY(100%);
  }
  20% {
    opacity: 1;
    transform: translateY(0%);
  }
  80% {
    opacity: 1;
    transform: translateY(0%);
  }
  90% {
    opacity: 0;
    transform: translateY(-100%);
  }
  100% {
    opacity: 0;
    transform: translateY(-100%);
  }
}
.loader-text-Wait {
  font-size: 20px;
  font-weight: bold;
  margin: 20px;
  min-height: 75px;
  text-align: center;
  animation: loader-text-Wait 5s infinite ease-in-out;
}
@keyframes loader-text-Wait {
  0% {
    opacity: 0;
    transform: translateY(100%);
  }
  10% {
    opacity: 0;
    transform: translateY(100%);
  }
  20% {
    opacity: 1;
    transform: translateY(0%);
  }
  80% {
    opacity: 1;
    transform: translateY(0%);
  }
  90% {
    opacity: 0;
    transform: translateY(-100%);
  }
  100% {
    opacity: 0;
    transform: translateY(-100%);
  }
}
.loader-text-Cancelled {
  font-size: 20px;
  font-weight: bold;
  margin: 20px;
  min-height: 50px;
  text-align: center;
  animation: loader-text-Cancelled 3.5s infinite ease-in-out;
}
@keyframes loader-text-Cancelled {
  0% {
    opacity: 0;
    transform: translateY(100%);
  }
  10% {
    opacity: 0;
    transform: translateY(100%);
  }
  20% {
    opacity: 1;
    transform: translateY(0%);
  }
  80% {
    opacity: 1;
    transform: translateY(0%);
  }
  90% {
    opacity: 0;
    transform: translateY(-100%);
  }
  100% {
    opacity: 0;
    transform: translateY(-100%);
  }
}
.loader-text-OnHold {
  font-size: 20px;
  font-weight: bold;
  margin: 20px;
  min-height: 75px;
  text-align: center;
  animation: loader-text-OnHold 4s infinite ease-in-out;
}
@keyframes loader-text-OnHold {
  0% {
    opacity: 0;
    transform: translateY(100%);
  }
  10% {
    opacity: 0;
    transform: translateY(100%);
  }
  20% {
    opacity: 1;
    transform: translateY(0%);
  }
  80% {
    opacity: 1;
    transform: translateY(0%);
  }
  90% {
    opacity: 0;
    transform: translateY(-100%);
  }
  100% {
    opacity: 0;
    transform: translateY(-100%);
  }
}
.loader-text-Didnt-Receive {
  font-size: 20px;
  font-weight: bold;
  margin: 20px;
  min-height: 75px;
  text-align: center;
  animation: loader-text-Didnt-Receive 3.9s infinite ease-in-out;
}
@keyframes loader-text-Didnt-Receive {
  0% {
    opacity: 0;
    transform: translateY(100%);
  }
  10% {
    opacity: 0;
    transform: translateY(100%);
  }
  20% {
    opacity: 1;
    transform: translateY(0%);
  }
  80% {
    opacity: 1;
    transform: translateY(0%);
  }
  90% {
    opacity: 0;
    transform: translateY(-100%);
  }
  100% {
    opacity: 0;
    transform: translateY(-100%);
  }
}
.loader-text-Not-Available {
  font-size: 20px;
  font-weight: bold;
  margin: 20px;
  min-height: 75px;
  text-align: center;
  animation: loader-text-Not-Available 4s infinite ease-in-out;
}
@keyframes loader-text-Not-Available {
  0% {
    opacity: 0;
    transform: translateY(100%);
  }
  10% {
    opacity: 0;
    transform: translateY(100%);
  }
  20% {
    opacity: 1;
    transform: translateY(0%);
  }
  80% {
    opacity: 1;
    transform: translateY(0%);
  }
  90% {
    opacity: 0;
    transform: translateY(-100%);
  }
  100% {
    opacity: 0;
    transform: translateY(-100%);
  }
}
.v2-req-phys-wrap .v2-rpc-lbl {
  color: var(--ion-color-text);
}
.v2-rpc-note {
  margin: 0.25rem 0 0;
  color: var(--ion-color-text);
  font-size: 0.9rem;
}
/*# sourceMappingURL=v2-request-physical-collection.component.css.map */
